import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';

const imgStyle = {
  overflow: 'auto'
};

export default function ButtonAppBar() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ height: 150, bgcolor: '#003553' }}>
        <Toolbar>
          <img style={imgStyle} src="http://imamreza.ac.ir/portal/dev/images/rlogo.png" alt="" ></img>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
